import React from 'react';
import {Field} from 'redux-form';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

String.prototype.insert = function ( index, string ) {
    if ( index > 0 )
        return this.substring( 0, index ) + string + this.substring( index, this.length );
    else
        return string + this;
};

const intRange = ( _min, _max ) => {
    return ( value, previousValue ) => {
        //if ( !value ) return value;
        try {
            if ( value < _min || value > _max ) {
                return previousValue;
            }
            return value;
        }
        catch(e){
            return previousValue;
        }
    }
};
const isNumber = ( value, previousValue ) => {
    if ( !value ) return value;
    let n = Number.parseInt( value );
    if ( isNaN( n ) ) {
        return previousValue;
    }
    return n;
};

const normalizer = ( normalizers ) => {
    return ( value, previousValue ) => {
        if ( !value ) return value;
        let v = value;
        normalizers.forEach( ( n ) => {
            v = n( v, previousValue );
        } );
        return v;
    }
};
class CourseInformation extends React.Component {
    constructor( props ) {
        super( props );
    }

    handleDateChange( evt ) {

    }

    render() {
        if ( !this.props.visible ) return null;
        const style = this.props.errorStyle;
        let nextSemYearData = [{value: '',name:'-- Select Year --', selected: 'selected'}];
       let thisYear =  new Date().getFullYear();
       for(let index=thisYear;index<thisYear+4;index++){
           nextSemYearData.push({value: index, name: index})
       }
        const labels = (this.props.office && this.props.office.labels) || {};
        return (
            <fieldset id="courseFields">
                <legend>Course Information</legend>
                <div className="paragraph">
                    <label style={style( 'courseNumber' ).label} htmlFor="courseNumber">Course Number <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'courseNumber' ).input} name="courseNumber" type="text" component="input"
                           maxLength="15"/>
                    <span className="inputValueExample">(<i>e.g.,</i> HIST 364)</span>
                </div>
                <div className="paragraph">
                    <label style={style( 'courseName' ).label} htmlFor="courseName">Course Name <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'courseName' ).input} name="courseName" type="text" component="input"
                           maxLength="120"/>
                    <span className="inputValueExample">(<i>e.g.,</i> Philosophy of Religion)</span>
                </div>
                {this.props.office.values.moduleType &&
                <div className="paragraph">
                    <label style={style( 'moduleType' ).label} htmlFor="semestersOffered">Course Type/Level <span
                        className="requiredAsterisk">*</span></label>
                    <Field style={style( 'moduleType' ).input} component="select" name="moduleType">
                        <option value="" selected="selected">-- Select Type --</option>
                        {this.props.office.values.moduleType && this.props.office.values.moduleType.map( ( e, i ) =>
                            <option key={i} value={e.value}>{e.label}</option>
                        )}
                    </Field>
                    {this.props.office.values.moduleLevel &&
                    <Field style={style( 'moduleLevel' ).input} component="select" name="moduleLevel">
                        <option value="" selected="selected">-- Select Level --</option>
                        {this.props.office.values.moduleLevel && this.props.office.values.moduleLevel.map( ( e, i ) =>
                            <option key={i} value={e.value}>{e.label}</option>
                        )}
                    </Field>
                    }
                </div>
                }
                {this.props.office.values.moduleType &&
                <div className="paragraph">
                    <label style={style( 'nextSemesterOffered' ).label} htmlFor="semestersOffered">Next Term Offered<span
                        className="requiredAsterisk">*</span></label>
                    <Field style={style( 'nextSemesterOffered' ).input} component="select" name="nextSemMonth">
                        <option value="" selected="selected">-- Select Term --</option>
                        {this.props.office.values.semesters && this.props.office.values.semesters.map( ( e, i ) =>
                            <option key={i} value={e.value}>{e.label}</option>
                        )}
                    </Field>
                    <Field style={style( 'nextSemesterOffered' ).input} component="select" name="nextSemYear">
                    {
                         nextSemYearData.map((e, key) => {
                                return <option key={key} value={e.value}>{e.name}</option>;
                    })}
                    </Field>
                </div>
                }
                {!this.props.office.values.moduleType &&
                <div className="paragraph">
                    <label style={style( 'nextSemesterOffered' ).label} htmlFor="semestersOffered">Next Semester Offered<span
                        className="requiredAsterisk">*</span></label>
                    <Field style={style( 'nextSemesterOffered' ).input} component="select" name="nextSemMonth">
                        <option value="" selected="selected">-- Select Semester --</option>
                        {this.props.office.values.semesters && this.props.office.values.semesters.map( ( e, i ) =>
                            <option key={i} value={e.value}>{e.label}</option>
                        )}
                    </Field>
                    <Field style={style( 'nextSemesterOffered' ).input} component="select" name="nextSemYear">
                    {
                         nextSemYearData.map((e, key) => {
                                return <option key={key} value={e.value}>{e.name}</option>;
                    })}
                    </Field>
                </div>
                }
                <div className="paragraph">
                    <label style={style( 'enrollment' ).label} htmlFor="enrollment">
                        {labels.enrollment || 'Course Enrollment'}&nbsp;
                        <span className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'enrollment' ).input} name="enrollment" type="number" maxLength="4"
                           normalize={normalizer([isNumber, intRange(1, 9999)])}
                           component="input"/>
                </div>
                <div className="paragraph">
                    <label style={style( 'productInUse' ).label} htmlFor="productInUse">Book In Use (Title/Author) <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'productInUse' ).input} name="productInUse" type="text" maxLength="60"
                           component="input"/>
                </div>
                {this.props.office.values.likelihoodOfAdoption &&
                <div className="paragraph">
                    <label style={style( 'likelihoodOfAdoption' ).label} htmlFor="likelihoodOfAdoption">Likelihood of
                        Adoption <span
                            className="requiredAsterisk">*</span>
                    </label>
                    <table>
                        <tbody>
                        {this.props.office.values.likelihoodOfAdoption.map( ( e, i ) =>
                            <tr key={i}>
                                <td><Field component="input" name="likelihoodOfAdoption" type="radio"
                                     value={(this.props.office.code === "ca" || this.props.office.code === "us") ? e.label : e.value}/></td>
                                <td style={{ verticalAlign: 'text-top' }}
                                    dangerouslySetInnerHTML={{ __html: e.label }}></td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                }
                {this.props.office.values.opportunityType &&
                <div className="paragraph">
                    <label style={style( 'opportunityType' ).label} htmlFor="opportunityType">Reason for your request <span
                            className="requiredAsterisk">*</span>
                    </label>
                    <table>
                        <tbody>
                        {this.props.office.values.opportunityType.map( ( e, i ) =>
                            <tr key={i}>
                                <td><Field component="input" name="opportunityType" type="radio"
                                           value={e.value}/></td>
                                <td style={{ verticalAlign: 'text-top' }}
                                    dangerouslySetInnerHTML={{ __html: e.label }}></td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                }
            </fieldset>
        );
    }
}

export default connect( state => state )( CourseInformation );


// WEBPACK FOOTER //
// ./src/form/components/CourseInformation.jsx